import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./headsup-modal.scss";

const HeadsupModal = (props) => {
  return (
    <div className="heads-up-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{"Just a heads up"}</div>
      <div className="sub-text">
        <p className="heads-up-content">
          {
            "For the most accurate look at your later life financial planning, including all your pots can be helpful to see how long all your money may last."
          }
        </p>
      </div>
      <div className="text-end mt-4">
        <Buttons
          className="secondary"
          name={"Back"}
          handleClick={props.handleCloseButton}
        />
        <Buttons
          className={`primary`}
          name={"Use my selection"}
          handleClick={props.handleClick}
        />
      </div>
    </div>
  );
};

export default HeadsupModal;
